import {History} from "history";

import {API_BASE_URL} from "../utils/constants";
import {ApiJsonResponse, callSecuredApiEndpoint} from "./apiCalls";

export type MemberSchemeData = {
    blocked: boolean;
    id: number;
    urn: string | null;
    name: string | null;
    schemeName: string | null;
    clientName: string | null;
    memberEmail: string | null;
    memberId: string | null;
    nationalInsuranceNumber: string | null;
    securityCode: string | null;
    sex: string | null;
    verified: boolean;
    suspended: boolean | null;
    registrationId: string;
}

export type MeberSchemesMetadata = {
    totalPages: number;
    totalElements: number;
    last: boolean;
    number: number; // page index
    sort: {
        sorted: boolean;
        unsorted: boolean;
        empty: boolean;
    };
    size: number;
    first: boolean;
    numberOfElements: number;
    empty: false;
    pageable: {
        offset: number;
        pageNumber: number;
        pageSize: number;
        paged: boolean;
        unpaged: boolean;
    };
}

export interface MembersRequestJson extends ApiJsonResponse, MeberSchemesMetadata {
    content: MemberSchemeData[];
}

/**
 * Definition of fetch call for members endpoint
 */
const requestMembers = (query: string) => (authorization: string) =>
    fetch(
        `${API_BASE_URL}member-schemes?${query}`,
        {
            headers: new window.Headers({
                Authorization: authorization
            }),
            method: "GET"
        }
    ).then(response => response.json()) as Promise<MembersRequestJson>;


export const getMembers = (query: string, history: History) => callSecuredApiEndpoint(requestMembers(query), history);

export interface TpClientData {
    id: string;
    name: string;
}

export interface ClientsRequestJson extends ApiJsonResponse {
    clients: TpClientData[];
}

const requestClients = (authorization: string) => fetch(
    `${API_BASE_URL}clients`,
    {
        headers: new window.Headers({
            Authorization: authorization
        }),
        method: "GET"
    }
).then(response => response.json()) as Promise<ClientsRequestJson>;


export const getClients = (history: History) => callSecuredApiEndpoint(requestClients, history);


export interface TpSchemeData {
    id: string;
    name: string;
}

export interface SchemesRequestJson extends ApiJsonResponse {
    schemes: TpSchemeData[];
}


const requestSchemes = (authorization: string) => fetch(
    `${API_BASE_URL}schemes`,
    {
        headers: new window.Headers({
            Authorization: authorization
        }),
        method: "GET"
    }
).then(response => response.json()) as Promise<SchemesRequestJson>;

export const getSchemes = (history: History) => callSecuredApiEndpoint(requestSchemes, history);

const requestExport = (query: string) => (authorization: string) =>
    fetch(
        `${API_BASE_URL}member-schemes${query ? "?" : ""}${query}`,
        {
            headers: new window.Headers({
                Authorization: authorization,
                "Content-Type": "text/csv"
            }),
            method: "GET"
        }
    ).then(response => response.blob()) as Promise<any>;


export const getExportCsv = (query: string, history: History) => callSecuredApiEndpoint(requestExport(query), history);

export interface SchemeActionResponse extends ApiJsonResponse {
    success: boolean;
}

const suspendMemberSchemeRequest = (schemeId: string) => (authorization: string) => fetch(
    `${API_BASE_URL}member-schemes/${schemeId}/suspend`,
    {
        headers: new window.Headers({
            Authorization: authorization
        }),
        method: "PUT"
    }
).then(response => ({
    success: response.status === 204
})) as Promise<SchemeActionResponse>;

export const suspendMemberScheme = (id: string, history: History) => callSecuredApiEndpoint(suspendMemberSchemeRequest(id), history);

const resumeMemberSchemeRequest = (schemeId: string) => (authorization: string) => fetch(
    `${API_BASE_URL}member-schemes/${schemeId}/resume`,
    {
        headers: new window.Headers({
            Authorization: authorization
        }),
        method: "PUT"
    }
).then(response => ({
    success: response.status === 204
})) as Promise<SchemeActionResponse>;

export const resumeMemberScheme = (id: string, history: History) => callSecuredApiEndpoint(resumeMemberSchemeRequest(id), history);

const deleteMemberSchemeRequest = (schemeId: string) => (authorization: string) => fetch(
    `${API_BASE_URL}member-schemes/${schemeId}`,
    {
        headers: new window.Headers({
            Authorization: authorization
        }),
        method: "DELETE"
    }
).then(response => ({
    success: response.status === 204
})) as Promise<SchemeActionResponse>;

export const deleteMemberScheme = (id: string, history: History) => callSecuredApiEndpoint(deleteMemberSchemeRequest(id), history);

export const sendPushNotification = (memberId: string, title: string, message: string) =>  fetch(
    `${API_BASE_URL}mpid/members/me/notification`,
    {
        method: "POST",
        mode: "cors",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
            memberId,
            title,
            message,
            "status": 1
        })
    }
).then(response => response.json());


export const blockMemberScheme = (registrationId: string) => fetch(
    `${API_BASE_URL}mpid/blockUser`,
    {
        headers: {"Content-Type": "application/json"},
        method: "POST",
        mode: "cors",
        body: JSON.stringify({
            "registrationId": registrationId,
            "status": false
        })
    }
).then(response => response.json());

export const unblockMemberScheme = (registrationId: string) => fetch(
    `${API_BASE_URL}mpid/blockUser`,
    {
        headers: {"Content-Type": "application/json"},
        method: "POST",
        mode: "cors",
        body: JSON.stringify({
            "registrationId": registrationId,
            "status": true
        })
    }
).then(response => response.json());

// export const blockMemberScheme = (registrationId: string, history: History) => callSecuredApiEndpoint(blockMemberSchemeRequest(registrationId), history);


